import type { ApiRoute, NoBody, NoPathParams } from "../../../api"
import type { TechnicalDataView } from "./TechnicalDataView"

export interface GetTechnicalDataQueryParams {
	"inventory-id": string
}

export const getTechnicalDataRoute: ApiRoute<NoPathParams, GetTechnicalDataQueryParams, NoBody, TechnicalDataView> = {
	buildUrl: () => "/technical-data",
	method: "get",
	path: "/technical-data",
}
